import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "title text--center" }
const _hoisted_3 = { class: "box box-platinum d-flex align-center justify-center" }
const _hoisted_4 = { class: "box-text text--center" }
const _hoisted_5 = { class: "box box-gold d-flex align-center justify-center" }
const _hoisted_6 = { class: "box-text text--center" }
const _hoisted_7 = { class: "box box-silver d-flex align-center justify-center" }
const _hoisted_8 = { class: "box-text text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_sponsor_platinum = _resolveComponent("sponsor-platinum")!
  const _component_sponsor_gold = _resolveComponent("sponsor-gold")!
  const _component_sponsor_silver = _resolveComponent("sponsor-silver")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          class: "justify-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("sponsors.title")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    ($setup.sponsorsPremium && $setup.sponsorsPremium.length > 0)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: "box__container"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("sponsors.platinum")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 24,
              class: "platinum__container"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sponsorsPremium, (sponsor, id) => {
                  return (_openBlock(), _createBlock(_component_sponsor_platinum, {
                    class: "center-items",
                    key: id,
                    id: sponsor.id,
                    picture: sponsor.picture,
                    name: sponsor.name,
                    description: sponsor.description,
                    sponsorship: sponsor.sponsorship
                  }, null, 8, ["id", "picture", "name", "description", "sponsorship"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.sponsorsGold && $setup.sponsorsGold.length > 0)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          gutter: 20,
          class: "gold__container d-flex align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("sponsors.gold")), 1)
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sponsorsGold, (sponsor, id) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                class: "sponsor__container",
                key: id,
                xs: 24,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_sponsor_gold, {
                    class: "center-items",
                    id: sponsor.id,
                    picture: sponsor.picture,
                    name: sponsor.name,
                    description: sponsor.description,
                    sponsorship: sponsor.sponsorship
                  }, null, 8, ["id", "picture", "name", "description", "sponsorship"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.sponsorsSilver && $setup.sponsorsSilver.length > 0)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 2,
          gutter: 20,
          class: "silver__container d-flex align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("sponsors.silver")), 1)
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sponsorsSilver, (sponsor, id) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: id,
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 6,
                class: "mt-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_sponsor_silver, {
                    class: "center-items",
                    id: sponsor.id,
                    picture: sponsor.picture,
                    name: sponsor.name,
                    description: sponsor.description,
                    sponsorship: sponsor.sponsorship
                  }, null, 8, ["id", "picture", "name", "description", "sponsorship"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, $setup.validateExistDatas]
  ])
}